import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import CtaText from 'components/ui/CtaCard';
import TrashIcon from 'assets/trash.png';
import RightArrowIcon from 'assets/right_arrow.png';
import {
  PURCHASE_ORDER_CATALOG_ITEM_FORM,
  NEW_PURCHASE_ORDER_CATALOG_ITEM_FORM,
} from './AddPurchaseOrderDrawer';
import { formatMoney } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
import MediaQuery from 'react-responsive';
import { media } from 'helpers/MediaHelper';

const StyledImg = styled.img`
  height: 15px;

  ${media.mobile`
    height: 19px;
  `};
`;

const StyledPurchaseOrderTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px;
  background-color: white;
  border-radius: 12px;
  margin-bottom: 32px;
`;

const StyledPurchaseOrderTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const StyledPurchaseOrderTableBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledPurchaseOrderTableRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0px;
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
`;

const StyledPurchaseOrderTableCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: ${props => props.width || '20%'};
  text-align: ${props => props.textAlign || 'left'};
  color: ${props => props.color || 'black'};
`;

const StyledIconContainer = styled.div`
  width: 100%;
  align-self: center;
  display: flex;
  margin-bottom: 3px;
  justify-content: space-evenly;
`;

const StyledNameDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledName = styled.h5`
  margin: 0;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledOverflowText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledMobileViewDetailsContainer = styled.div`
  text-align: center;
  margin-top: 10px;
  color: rgb(35, 12, 194);
`;

export const PurchaseOrderItemList = ({
  data,
  setPurchaseOrderFormStep,
  removePurchaseOrderItem,
  editPurchaseOrderCatalogItem,
  vendorHasCatalogItems,
}) => {
  const [purchaseOrderItems, setPurchaseOrderItems] = useState([]);

  useEffect(
    () => {
      if (data) {
        setPurchaseOrderItems(data);
      }
    },
    [data]
  );

  return (
    <div>
      <MediaQuery query="(min-device-width: 750px)">
        <StyledPurchaseOrderTableContainer>
          <StyledPurchaseOrderTableHeader>
            <StyledPurchaseOrderTableCell color="#828282" width="40%">
              {getTranslatedString('landlordPortal.purchaseOrderItemList.itemUpcase')}
            </StyledPurchaseOrderTableCell>
            <StyledPurchaseOrderTableCell color="#828282" width="10%" textAlign="right">
              {getTranslatedString('landlordPortal.purchaseOrderItemList.unitUpcase')}
            </StyledPurchaseOrderTableCell>
            <StyledPurchaseOrderTableCell color="#828282" width="15%" textAlign="right">
              {getTranslatedString('landlordPortal.purchaseOrderItemList.itemCostUpcase')}
            </StyledPurchaseOrderTableCell>
            <StyledPurchaseOrderTableCell color="#828282" width="10%" textAlign="right">
              {getTranslatedString('landlordPortal.purchaseOrderItemList.qtyUpcase')}
            </StyledPurchaseOrderTableCell>
            <StyledPurchaseOrderTableCell color="#828282" width="15%" textAlign="right">
              {getTranslatedString('landlordPortal.purchaseOrderItemList.totalUpcase')}
            </StyledPurchaseOrderTableCell>
            <StyledPurchaseOrderTableCell width="10%" />
          </StyledPurchaseOrderTableHeader>
          <StyledPurchaseOrderTableBody>
            {purchaseOrderItems.map((purchaseOrderItem, index) => (
              <StyledPurchaseOrderTableRow>
                <StyledPurchaseOrderTableCell width="40%">
                  <StyledNameDescriptionContainer>
                    <StyledName>{purchaseOrderItem.item_name}</StyledName>
                    <StyledOverflowText>
                      {purchaseOrderItem.item_number
                        ? purchaseOrderItem.item_number
                        : purchaseOrderItem.item_description}
                    </StyledOverflowText>
                  </StyledNameDescriptionContainer>
                </StyledPurchaseOrderTableCell>
                <StyledPurchaseOrderTableCell width="10%" textAlign="right">
                  {purchaseOrderItem.unit_number}
                </StyledPurchaseOrderTableCell>
                <StyledPurchaseOrderTableCell width="15%" textAlign="right">
                  <StyledOverflowText>
                    {formatMoney(purchaseOrderItem.estimated_cost)}
                  </StyledOverflowText>
                </StyledPurchaseOrderTableCell>
                <StyledPurchaseOrderTableCell width="10%" textAlign="right">
                  {purchaseOrderItem.quantity}
                </StyledPurchaseOrderTableCell>
                <StyledPurchaseOrderTableCell width="15%" textAlign="right">
                  <StyledOverflowText>
                    {formatMoney(purchaseOrderItem.total_cost)}
                  </StyledOverflowText>
                </StyledPurchaseOrderTableCell>
                <StyledPurchaseOrderTableCell width="10%">
                  <StyledIconContainer>
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => removePurchaseOrderItem(index)}
                    >
                      <StyledImg alt="" src={TrashIcon} />
                    </div>
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => editPurchaseOrderCatalogItem(index)}
                    >
                      <StyledImg alt="" src={RightArrowIcon} />
                    </div>
                  </StyledIconContainer>
                </StyledPurchaseOrderTableCell>
              </StyledPurchaseOrderTableRow>
            ))}
          </StyledPurchaseOrderTableBody>
          <CtaText
            type="button"
            onClick={() =>
              vendorHasCatalogItems
                ? setPurchaseOrderFormStep(PURCHASE_ORDER_CATALOG_ITEM_FORM)
                : setPurchaseOrderFormStep(NEW_PURCHASE_ORDER_CATALOG_ITEM_FORM)}
          >
            {getTranslatedString('landlordPortal.purchaseOrderItemList.addAnotherItem')}
          </CtaText>
        </StyledPurchaseOrderTableContainer>
      </MediaQuery>

      <MediaQuery query="(max-device-width: 750px)">
        {purchaseOrderItems.map((purchaseOrderItem, index) => (
          <StyledPurchaseOrderTableContainer>
            <StyledPurchaseOrderTableRow>
              <StyledPurchaseOrderTableCell>
                <StyledName>{purchaseOrderItem.item_name}</StyledName>
                <StyledOverflowText>{purchaseOrderItem.item_description}</StyledOverflowText>
              </StyledPurchaseOrderTableCell>
              <StyledPurchaseOrderTableCell textAlign="right" width="10%">
                <StyledIconContainer>
                  <div style={{ cursor: 'pointer' }} onClick={() => removePurchaseOrderItem(index)}>
                    <StyledImg alt="" src={TrashIcon} />
                  </div>
                </StyledIconContainer>
              </StyledPurchaseOrderTableCell>
            </StyledPurchaseOrderTableRow>

            <StyledPurchaseOrderTableRow>
              <StyledPurchaseOrderTableCell>
                <div>{getTranslatedString('landlordPortal.purchaseOrderItemList.unitUpcase')}</div>
                <div>{purchaseOrderItem.unit_number}</div>
              </StyledPurchaseOrderTableCell>
              <StyledPurchaseOrderTableCell textAlign="right">
                <div>
                  {getTranslatedString('landlordPortal.purchaseOrderItemList.itemCostUpcase')}
                </div>
                <div>{formatMoney(purchaseOrderItem.estimated_cost)}</div>
              </StyledPurchaseOrderTableCell>
            </StyledPurchaseOrderTableRow>

            <StyledPurchaseOrderTableRow>
              <StyledPurchaseOrderTableCell>
                <div>{getTranslatedString('landlordPortal.purchaseOrderItemList.qtyUpcase')}</div>
                <div>{purchaseOrderItem.quantity}</div>
              </StyledPurchaseOrderTableCell>
              <StyledPurchaseOrderTableCell textAlign="right">
                <div>{getTranslatedString('landlordPortal.purchaseOrderItemList.totalUpcase')}</div>
                <div>{formatMoney(purchaseOrderItem.total_cost)}</div>
              </StyledPurchaseOrderTableCell>
            </StyledPurchaseOrderTableRow>

            <StyledMobileViewDetailsContainer
              style={{ cursor: 'pointer' }}
              onClick={() => editPurchaseOrderCatalogItem(index)}
            >
              {getTranslatedString('landlordPortal.purchaseOrderItemList.viewDetails')}
            </StyledMobileViewDetailsContainer>
          </StyledPurchaseOrderTableContainer>
        ))}
        <StyledPurchaseOrderTableCell>
          <CtaText
            type="button"
            onClick={() =>
              vendorHasCatalogItems
                ? setPurchaseOrderFormStep(PURCHASE_ORDER_CATALOG_ITEM_FORM)
                : setPurchaseOrderFormStep(NEW_PURCHASE_ORDER_CATALOG_ITEM_FORM)}
            style={{ paddingTop: '0px' }}
          >
            {getTranslatedString('landlordPortal.purchaseOrderItemList.addAnotherItem')}
          </CtaText>
        </StyledPurchaseOrderTableCell>
      </MediaQuery>
    </div>
  );
};
